import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const HelpDialog = ({ open, close }) => {
  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle id="alert-dialog-title">{"Here's how it works"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          If you like the person on stage and want to put yourself forward to go
          up there with them, hit that heart button!
        </DialogContentText>
        <br />
        <DialogContentText>
          If you get picked, the room votes. Keep this screen open and it will
          change on its own when it is time to vote.
        </DialogContentText>
        <br />
        <DialogContentText>
          If you still have questions, please do not hesitate to ask an event
          host.
        </DialogContentText>
        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpDialog;
